export const ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=nz.co.skygo';
export const IOS_APP_LINK = 'https://apps.apple.com/nz/app/sky-go-companion-app/id1541957275';
